import React, { useState, useEffect } from 'react';
import { tippspielAdminAPI } from '../../services/api';

const TippspielRulesSettings = () => {
  const [visibility, setVisibility] = useState({});
  const [deadlines, setDeadlines] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    tippspielAdminAPI.getSettings()
      .then((res) => {
        setVisibility(res.data.visibilityRules || {});
        setDeadlines(res.data.deadlineRules || {});
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    setError('');
    try {
      await Promise.all([
        tippspielAdminAPI.updateVisibility(visibility),
        tippspielAdminAPI.updateDeadlines(deadlines),
      ]);
      setMessage('Regeln gespeichert.');
    } catch (err) {
      setError(err.response?.data?.message || 'Speichern fehlgeschlagen');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center py-12"><span className="loading loading-spinner loading-lg text-wacker" /></div>;
  }

  return (
    <div className="space-y-6">
      <h2 className="section-title"><span>Regeln</span></h2>
      {error && <div className="alert-error-dark">{error}</div>}
      {message && <div className="alert-success-dark">{message}</div>}

      <div className="glass-card p-6 space-y-4">
        <h3 className="font-semibold text-white">Sichtbarkeit</h3>
        {[
          ['showTipsBeforeKickoff', 'Tipps vor Anpfiff anzeigen'],
          ['showOthersAfterDeadline', 'Fremde Tipps nach Deadline anzeigen'],
          ['showLeaderboardDuringSeason', 'Rangliste während der Saison'],
          ['hideUnplayedMatchTips', 'Tipps ungespielter Spiele verbergen'],
        ].map(([key, label]) => (
          <label key={key} className="flex items-center gap-2 cursor-pointer text-white/80">
            <input
              type="checkbox"
              className="admin-checkbox"
              checked={Boolean(visibility[key])}
              onChange={(e) => setVisibility({ ...visibility, [key]: e.target.checked })}
            />
            {label}
          </label>
        ))}
      </div>

      <div className="glass-card p-6 space-y-4">
        <h3 className="font-semibold text-white">Deadlines</h3>
        <div className="max-w-xs">
          <label className="label-dark">Minuten vor Anpfiff</label>
          <input
            type="number"
            className="admin-input"
            value={deadlines.defaultMinutesBeforeKickoff ?? 15}
            onChange={(e) => setDeadlines({ ...deadlines, defaultMinutesBeforeKickoff: parseInt(e.target.value, 10) || 0 })}
          />
        </div>
        <label className="flex items-center gap-2 cursor-pointer text-white/80">
          <input
            type="checkbox"
            className="admin-checkbox"
            checked={deadlines.allowTipChangesUntilDeadline !== false}
            onChange={(e) => setDeadlines({ ...deadlines, allowTipChangesUntilDeadline: e.target.checked })}
          />
          Tipps bis Deadline änderbar
        </label>
        <div className="max-w-md">
          <label className="label-dark">Verhalten bei Spielverlegung</label>
          <select
            className="admin-select"
            value={deadlines.postponedMatchBehavior || 'resetFromNewKickoff'}
            onChange={(e) => setDeadlines({ ...deadlines, postponedMatchBehavior: e.target.value })}
          >
            <option value="resetFromNewKickoff">Deadline vom neuen Anpfiff</option>
            <option value="keepOriginal">Ursprüngliche Deadline behalten</option>
          </select>
        </div>
      </div>

      <button type="button" className="btn-wacker text-sm py-2 px-4" disabled={saving} onClick={handleSave}>
        {saving ? 'Speichern…' : 'Regeln speichern'}
      </button>
    </div>
  );
};

export default TippspielRulesSettings;
